import { ConfigProvider, Flex } from 'antd';
import classNames from 'classnames';
import { PropsWithChildren, ReactNode } from 'react';

import layoutStyles from 'business/layout/single-card-page-with-filter-card/layout.module.scss';
import Routes from 'config/routes';
import { PreviousPageButton } from 'ui/button/previous-page-button';
import { ContentTitle } from 'ui/content-title';
import { SimpleCard } from 'ui/SimpleCard';

export const MobileSingleCardPageWithFilterLayout = ({
  title,
  filters,
  corner,
  children,
  mainPageRedirection,
}: PropsWithChildren<{
  title?: string;
  filters?: ReactNode;
  corner?: ReactNode;
  mainPageRedirection?: Routes;
}>) => {
  return (
    <div
      className={classNames(
        layoutStyles.page,
        layoutStyles.flexContainerMobile,
        'page-appear',
      )}
    >
      <ConfigProvider
        theme={{
          components: {
            Card: {
              bodyPadding: 14,
            },
          },
        }}
      >
        {mainPageRedirection ? (
          <PreviousPageButton
            to={mainPageRedirection}
            label="common.to_main_page"
            isMobile
          />
        ) : null}
        <SimpleCard>
          <Flex vertical gap={22}>
            <Flex justify="space-between">
              {title ? <ContentTitle>{title}</ContentTitle> : null}
              {corner ? corner : null}
            </Flex>
            {filters ? filters : null}
            {children}
          </Flex>
        </SimpleCard>
      </ConfigProvider>
    </div>
  );
};
